import React, { Suspense } from "react";
import { DepositPhase, DepositState } from "../payments/PaymentsReducer";
import { Settings, UserInfo } from "../http/protocol";
import CoinpaymentsPaymentComponent from "../ui/paymentproviders/CoinpaymentsPaymentComponent";
import SimbetPaymentComponent from "../ui/paymentproviders/SimbetPaymentComponent";
import GBLPaymentComponent from "../ui/paymentproviders/GBLPaymentComponent";
import { TestPaymentComponent } from "../ui/paymentproviders/TestPaymentComponent";
import AgentPaymentComponent from "../ui/paymentproviders/AgentPaymentComponent";
import VoucherPaymentComponent from "../ui/paymentproviders/VoucherPaymentComponent";
import NanoPaymentComponent from "../ui/paymentproviders/NanoPaymentComponent";
import { MayaMiniAppDepositPaymentComponent } from "../ui/paymentproviders/MayaMiniAppDepositPaymentComponent";
import { GlifePaymentComponent } from "../ui/paymentproviders/GlifeDepositPaymentComponent";
import ChooseAmount from "../ui/deposit/ChooseAmount";
import DepositProviderContent from "../ui/deposit/DepositProviderContent";
import DepositResultView from "../ui/deposit/DepositResultView";
import { PaymentLoading } from "./PaymentLoading";

const PaymentIQPaymentComponent = React.lazy(() => import("../ui/paymentproviders/PaymentIQPaymentComponent"));

type Providers = "coinpayments" | "simbet" | "gbl" | "test" | "agent" | "voucher" | "paymentiq" | "nowpayments" | "mayaminiapp" | "glife" | string;

interface DepositProviderSpecificProps {
  provider: Providers;
  deposit: DepositState;
  code?: string;
  settings?: Settings;
  user?: UserInfo;
  handleClickStartPlaying: () => void;
}

const DepositProviderSpecific = ({ deposit, provider, code, handleClickStartPlaying, settings, user }: DepositProviderSpecificProps) => {
  switch (provider) {
    case "coinpayments":
      return <CoinpaymentsPaymentComponent type="deposit" handleClickStartPlaying={handleClickStartPlaying} code={code} />;
    case "simbet":
      return <SimbetPaymentComponent type="deposit" handleClickStartPlaying={handleClickStartPlaying} />;
    case "gbl":
      return <GBLPaymentComponent type="deposit" handleClickStartPlaying={handleClickStartPlaying} code={code} />;
    case "test":
      return (
        <TestPaymentComponent
          type="deposit"
          deposit={deposit}
          dialog={deposit.depositDialog}
          settings={settings}
          handleClickStartPlaying={handleClickStartPlaying}
        />
      );
    case "agent":
      return (
        <AgentPaymentComponent
          type="deposit"
          deposit={deposit}
          dialog={deposit.depositDialog}
          settings={settings}
          handleClickStartPlaying={handleClickStartPlaying}
        />
      );
    case "voucher":
      return (
        <VoucherPaymentComponent
          type="deposit"
          deposit={deposit}
          dialog={deposit.depositDialog}
          settings={settings}
          handleClickStartPlaying={handleClickStartPlaying}
        />
      );
    case "paymentiq":
      return (
        <Suspense fallback={<PaymentLoading />}>
          <PaymentIQPaymentComponent
            type="deposit"
            userUid={user?.userUid!}
            deposit={deposit}
            dialog={deposit.depositDialog}
            settings={settings}
            handleClickStartPlaying={handleClickStartPlaying}
          />
        </Suspense>
      );
    case "nowpayments":
      return <NanoPaymentComponent handleClickStartPlaying={handleClickStartPlaying} type="deposit" code={code} amountRequired={false} />;
    case "mayaminiapp":
      return <MayaMiniAppDepositPaymentComponent handleClickStartPlaying={handleClickStartPlaying} />;
    case "glife":
      return <GlifePaymentComponent handleClickStartPlaying={handleClickStartPlaying} />;
    default:
      return (
        <div className="deposit-content">
          {deposit.phase === DepositPhase.CHOOSE_AMOUNT && deposit.activeMethod && <ChooseAmount />}
          {deposit.phase === DepositPhase.PROVIDER_CONTENT && <DepositProviderContent />}
          {deposit.phase === DepositPhase.DEPOSIT_RESULT && <DepositResultView />}
        </div>
      );
  }
};

export default DepositProviderSpecific;
